const doc = [({"da":({"js":({"admin":({"steps":({"element_feedback_option":({"possible_answer":"Muligt svar", "the_option_was_deleted":"Muligheden blev slettet"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;